import React from 'react';
import {Link} from 'react-router-dom';

export function canViewDetails(authenticated, subscriptionStatus) {
  return !!(authenticated && subscriptionStatus && subscriptionStatus.status === "active");
}

export const AccessGateMessage = ({authenticated, subscriptionStatus}) => {
  if (canViewDetails(authenticated, subscriptionStatus)) {
    return null;
  }
  if (!authenticated) {
    return <div className="alert callout callout-info">Please log in to view details</div>;
  }
  return (
    <div className="alert callout callout-info">
      You need an <Link className="app-link" to="/subscriptionStatus">active subscription</Link> to view details
    </div>
  );
};

const DetailsAccessGate = ({authenticated, subscriptionStatus, children}) => {
  if (canViewDetails(authenticated, subscriptionStatus)) {
    return children || null;
  }
  return <AccessGateMessage authenticated={authenticated} subscriptionStatus={subscriptionStatus}/>;
};

export default DetailsAccessGate;
